export function mountLeadForms(root) {
	const controllers = [];
	root.querySelectorAll("[data-solufy-lead-form]").forEach((form) => {
		const controller = new AbortController();
		controllers.push(controller);
		form.addEventListener(
			"submit",
			async (event) => {
				event.preventDefault();
				const button = form.querySelector("button[type='submit']");
				const status = form.querySelector("[data-form-status]");
				button.disabled = true;

				status.textContent = "Sending…";
				try {
					const payload = new URLSearchParams(new FormData(form));
					const query = new URLSearchParams(window.location.search);
					payload.set("page", window.location.pathname);
					payload.set("referrer", document.referrer);
					["utm_source", "utm_medium", "utm_campaign"].forEach((key) =>
						payload.set(key, query.get(key) || ""),
					);
					const response = await fetch(
						"/api/method/solufy_website.api.leads.create_lead",
						{
							method: "POST",
							headers: {
								"Content-Type": "application/x-www-form-urlencoded",
								...(window.frappe?.csrf_token && window.frappe.csrf_token !== "None" ? { "X-Frappe-CSRF-Token": window.frappe.csrf_token } : {}),
							},
							body: payload,
							signal: controller.signal,
						},
					);
					const result = await response.json();
					if (!response.ok || result.exc) {
						let errMsg = "";
						if (result._server_messages) {
							try {
								errMsg = JSON.parse(result._server_messages).map((m) => JSON.parse(m).message).join(" ");
							} catch (e) {}
						}
						throw new Error(errMsg || result.message || "Request failed");
					}
					document.dispatchEvent(new CustomEvent("solufy:form-result", { detail: { form, success: true } }));
					form.reset();
					status.textContent = "Thank you. Our team will contact you shortly.";
				} catch (error) {
					document.dispatchEvent(new CustomEvent("solufy:form-result", { detail: { form, success: false } }));
					if (error.name !== "AbortError")
						status.textContent =
							error.message && error.message !== "Request failed"
								? error.message
								: "We could not send this yet. Please email or call us.";
				} finally {
					button.disabled = false;
				}
			},
			{ signal: controller.signal },
		);
	});
	return () => controllers.forEach((controller) => controller.abort());
}
